module.exports = __webpack_public_path__ + "media/images/wwf-cf3b874a49cc1d795c7e0801d288cd1a.png";